import React from 'react';
import About from './components/About';
import Services from './components/Services';
import Gallery from './components/Gallery';
import Home from './components/Home';
import Root from './components/Root';
import Accessibility from "./components/Accessibility";
import PreConstruction from "./components/Services/PreConstruction";
import NewBuild from "./components/Services/NewBuild";
import CommercialFitOut from "./components/Services/CommercialFitOut";
import StructuralWorks from "./components/Services/StructuralWorks";
import InteriorFitOut from "./components/Services/InteriorFitOut";
import DesignCoordination from "./components/Services/DesignCoordination";
import SiteManagementHandover from "./components/Services/SiteManagementHandover";
import './index.css';
import {RouterProvider, Route, createBrowserRouter, createRoutesFromElements, Navigate} from 'react-router-dom';

const router = createBrowserRouter( createRoutesFromElements(
  <Route path="/" element={ <Root /> } >
    <Route path="" element={ <Home /> } />
    <Route path="about" element={ <About /> } />
    <Route path="projects" >
      <Route index element={ <Navigate to="/projects/construction" replace /> } />
      <Route path="construction" element={ <Gallery initialGallery="construction"/> } />
      <Route path="kitchens" element={ <Gallery initialGallery="kitchens"/> } />
      <Route path="bathrooms" element={ <Gallery initialGallery="bathrooms"/> } />
      <Route path="full-home" element={ <Gallery initialGallery="full-home"/> } />
      <Route path="extensions" element={ <Gallery initialGallery="extensions"/> } />
      <Route path="outdoors" element={ <Gallery initialGallery="outdoors"/> } />
      <Route path="roofing" element={ <Gallery initialGallery="roofing"/> } />
    </Route>
    <Route path="gallery" >
      <Route index element={ <Navigate to="/projects/construction" replace /> } />
      <Route path="kitchens" element={ <Navigate to="/projects/kitchens" replace /> } />
      <Route path="bathrooms" element={ <Navigate to="/projects/bathrooms" replace /> } />
      <Route path="full-home" element={ <Navigate to="/projects/full-home" replace /> } />
      <Route path="extensions" element={ <Navigate to="/projects/extensions" replace /> } />
      <Route path="outdoors" element={ <Navigate to="/projects/outdoors" replace /> } />
      <Route path="roofing" element={ <Navigate to="/projects/roofing" replace /> } />
    </Route>
    <Route path="services">
      <Route index element={ <Services /> } />
      <Route path="pre-construction" element={ <PreConstruction /> } />
      <Route path="new-build" element={ <NewBuild /> } />
      <Route path="commercial-fit-out" element={ <CommercialFitOut /> } />
      <Route path="structural-works" element={ <StructuralWorks /> } />
      <Route path="interior-fit-out" element={ <InteriorFitOut /> } />
      <Route path="design-coordination" element={ <DesignCoordination /> } />
      <Route path="site-management-handover" element={ <SiteManagementHandover /> } />
    </Route>
    <Route path="accessibility" element={ <Accessibility /> } />
  </Route>
))

function App() {
  return (
    <RouterProvider router={ router } />
  );
}

export default App;
